(() => {
  'use strict';
  const sourceElement = document.getElementById('ct-catalog-sources');
  if (!sourceElement) return;
  const sources = JSON.parse(sourceElement.textContent);
  const requests = new Map();
  const prepared = new WeakSet();
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[đĐ]/g, 'd').replace(/[łŁ]/g, 'l').replace(/[øØ]/g, 'o').replace(/æ/gi, 'ae').replace(/ß/g, 'ss').toLowerCase();
  const isPlayer = item => item.type === 'player' || String(item.id || '').startsWith('PL-');
  const el = (name, className, text) => {
    const element = document.createElement(name);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  function load(source) {
    if (!source) return Promise.reject(new Error('Catalog source unavailable'));
    if (!requests.has(source)) {
      requests.set(source, fetch(source, {credentials: 'omit'}).then(response => {
        if (!response.ok) throw new Error('Catalog unavailable');
        return response.json();
      }).catch(error => { requests.delete(source); throw error; }));
    }
    return requests.get(source);
  }
  async function coreFor(panel) {
    const data = await load(panel.dataset.source);
    if (!prepared.has(data)) {
      if (!Array.isArray(data.groups) || !Array.isArray(data.teams)) throw new Error('Invalid catalog');
      data.byId = new Map(data.teams.map(team => [team.id, team]));
      data.teams.forEach(team => { team.search = normalize([team.n, team.a, team.g, team.c, team.s].join(' ')); });
      prepared.add(data);
    }
    return data;
  }
  async function playersFor(source, core) {
    const data = await load(source);
    if (!prepared.has(data)) {
      if (!Array.isArray(data.players)) throw new Error('Invalid player catalog');
      data.players.forEach(player => {
        player.teamNames = player.teams.map(id => core.byId.get(id)?.n).filter(Boolean);
        player.search = normalize([player.n, player.s, ...player.teamNames].join(' '));
        player.nameSearch = normalize([player.n, ...(player.a || [])].join(' '));
      });
      prepared.add(data);
    }
    return data;
  }
  function link(panel, item, className) {
    const anchor = el('a', className);
    anchor.href = panel.dataset.base.replace(/\/$/, '') + '/' + encodeURIComponent(item.h);
    return anchor;
  }
  function badge(panel, item) {
    if (item.b) {
      const image = el('img', 'ct-catalog-badge');
      image.src = panel.dataset.badgeBase + item.b;
      image.alt = '';
      image.width = image.height = 128;
      image.loading = 'lazy';
      image.decoding = 'async';
      return image;
    }
    const mark = el('span', 'ct-catalog-badge ct-catalog-badge--fallback ct-catalog-badge--letters', item.n.split(/\s+/).filter(Boolean).slice(0, 2).map(word => word[0]).join(''));
    mark.setAttribute('aria-hidden', 'true');
    return mark;
  }
  const collator = new Intl.Collator('en', {sensitivity: 'base', numeric: true});
  const alphabet = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const initial = item => {
    const first = normalize(item.n).trim().charAt(0).toUpperCase();
    return /^[A-Z]$/.test(first) ? first : '#';
  };
  const teamContext = core => core.teams.find(team => team.h === new URL(location.href).searchParams.get('ct_team'));
  const playerLink = (panel, player, team) => {
    const anchor = link(panel, player);
    if (team) {
      const url = new URL(anchor.href);
      url.searchParams.set('ct_team', team.h);
      anchor.href = url.href;
    }
    return anchor;
  };
  const choice = (panel, item, team, selected) => {
    const li = el('li');
    const anchor = isPlayer(item) ? playerLink(panel, item, team) : link(panel, item);
    const mark = isPlayer(item) ? el('span', 'ct-choice-mark') : badge(panel, item);
    mark.setAttribute('aria-hidden', 'true');
    if (selected) anchor.setAttribute('aria-current', 'page');
    anchor.append(mark, el('span', '', item.n));
    li.append(anchor);
    return li;
  };
  async function initRelated(panel, strings) {
    const output = panel.querySelector('[data-ct-directory-results]');
    try {
      const core = await coreFor(panel);
      let context = teamContext(core);
      let data = await playersFor(context ? sources.branches[context.parent] : sources.players, core);
      let player = data.players.find(item => item.h === panel.dataset.handle);
      if (context && (!player || !player.teams.includes(context.id))) {
        context = null;
        data = await playersFor(sources.players, core);
        player = data.players.find(item => item.h === panel.dataset.handle);
      }
      const byId = new Map(data.players.map(item => [item.id, item]));
      const items = context ? data.rosters[context.h].map(id => byId.get(id)).filter(Boolean) : (player?.teams || []).map(id => core.byId.get(id)).filter(Boolean);
      const heading = panel.querySelector('[data-ct-related-heading]');
      heading.textContent = context ? strings.players : strings.related;
      heading.append(el('span', '', String(items.length)));
      const box = el('div', 'ct-context-nav');
      box.setAttribute('data-ct-context', '');
      const label = el('label', 'ct-context-search');
      label.append(el('span', 'ct-sr-only', strings.filterChildren));
      const search = el('input');search.type = 'search';search.placeholder = strings.filterChildren;search.autocomplete = 'off';search.setAttribute('data-ct-context-search', '');label.append(search);
      const list = el('ul', 'ct-context-links');list.setAttribute('data-ct-context-links', '');
      items.forEach(item => list.append(choice(panel, item, context, item.id === (player?.alias_of || player?.id))));
      const empty = el('p', 'ct-context-no-results', strings.noChildren);empty.hidden = true;empty.setAttribute('data-ct-context-empty', '');
      box.append(label, list, empty);output.replaceChildren(box);
      if (context) {
        const parent = panel.closest('.ct-sidebar')?.querySelector('.ct-context-parent');
        if (parent) {parent.textContent = context.n;parent.href = link(panel, context).href;}
        const crumb = document.querySelector('.ct-breadcrumb a[href$="/ct-players"]');
        if (crumb) {crumb.textContent = context.n;crumb.href = link(panel, context).href;}
      }
      panel.hidden = items.length === 0;
      panel.dispatchEvent(new CustomEvent('ct:catalog-ready', {bubbles: true}));
    } catch {
      panel.hidden = false;
      const message = el('p', 'ct-context-no-results', strings.loadError + ' ');
      const retry = el('button', 'ct-text-link', strings.retry);retry.type = 'button';retry.addEventListener('click', () => initRelated(panel, strings), {once: true});
      message.append(retry);output.replaceChildren(message);
    }
  }
  function initBrowser(panel) {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const strings = JSON.parse(panel.querySelector('[data-ct-directory-strings]').textContent);
    if (panel.dataset.kind === 'related') {initRelated(panel, strings);return;}
    const playerView = panel.dataset.kind === 'players';
    const list = panel.querySelector('[data-ct-directory-results]');
    const status = panel.querySelector('[data-ct-directory-status]');
    const search = panel.querySelector('[data-ct-directory-search]');
    const sport = panel.querySelector('[data-ct-directory-sport]');
    const league = panel.querySelector('[data-ct-directory-league]');
    const rail = panel.querySelector('[data-ct-directory-alphabet]');
    const chips = [...panel.querySelectorAll('[data-ct-directory-group]')];
    const reset = panel.querySelector('[data-ct-directory-reset]');
    const more = panel.querySelector('[data-ct-directory-more]');
    const params = new URL(location.href).searchParams;
    search.value = params.get('ctq') || '';
    sport.value = params.get('ctsport') || '';
    let activeGroup = params.get('ctgroup') || '';
    if (!chips.some(chip => chip.dataset.ctDirectoryGroup === activeGroup)) activeGroup = '';
    let activeLetter = params.get('ctletter') || '';
    if (!alphabet.includes(activeLetter)) activeLetter = '';
    let core;
    let pool;
    let found = [];
    let visible = 24;
    let pending;
    let started = false;
    let loading = false;
    const letterButtons = new Map();
    ['', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '#'].forEach(letter => {
      const button = el('button', '', letter || strings.allLetters);button.type = 'button';button.dataset.letter = letter;button.setAttribute('aria-pressed', String(letter === activeLetter));
      button.addEventListener('click', () => {activeLetter = letter;filter();});rail.append(button);letterButtons.set(letter, button);
    });
    const rootOf = team => /^ct-(nfl|mlb|nba|nhl|mls)$/.test(team.parent) ? team.parent : team.parent.startsWith('ct-national-') ? 'ct-national-teams' : 'ct-european-football';
    const members = item => playerView ? item.teams.map(id => core.byId.get(id)).filter(Boolean) : [item];
    const withinScope = team => (!sport.value || team.s === sport.value) && (!activeGroup || rootOf(team) === activeGroup) && (!league.value || team.parent === league.value);
    const updateLeagues = value => {
      const groups = new Map(core.groups.map(group => [group.h, group.n]));
      const available = [...new Set(core.teams.filter(team => (!sport.value || team.s === sport.value) && (!activeGroup || rootOf(team) === activeGroup)).map(team => team.parent))].sort((a, b) => collator.compare(groups.get(a), groups.get(b)));
      league.replaceChildren(el('option', '', strings.allLeagues));league.firstChild.value = '';
      available.forEach(handle => {const option = el('option', '', groups.get(handle));option.value = handle;league.append(option);});
      league.value = available.includes(value) ? value : '';
    };
    const saveState = () => {
      if (document.querySelectorAll('.ct-browser').length !== 1) return;
      const url = new URL(location.href);
      for (const [key, value] of Object.entries({ctq: search.value.trim(), ctsport: sport.value, ctgroup: activeGroup, ctleague: league.value, ctletter: activeLetter})) {
        if (value) url.searchParams.set(key, value);else url.searchParams.delete(key);
      }
      history.replaceState(history.state, '', url);
    };
    const renderCard = item => {
      const li = el('li');
      const anchor = link(panel, item, 'ct-browser-card' + (playerView ? ' ct-browser-card--player' : ''));
      if (!playerView) anchor.append(badge(panel, item));
      const body = el('span', 'ct-browser-card__copy');body.append(el('strong', '', item.n));
      const detail = playerView ? item.teamNames.slice(0, 2).join(' · ') + (item.teamNames.length > 2 ? ' +' + (item.teamNames.length - 2) : '') : [...new Set([item.g, item.c].filter(Boolean))].join(' · ');
      const meta = el('small', '', detail);if (playerView) meta.title = item.teamNames.join(', ');body.append(meta);anchor.append(body);li.append(anchor);return li;
    };
    const paint = () => {
      const fragment = document.createDocumentFragment();
      let previous = '';
      let groupList;
      const grouped = !search.value.trim();
      if (!grouped) {groupList = el('ul', 'ct-browser-list ct-browser-list--search');fragment.append(groupList);}
      found.slice(0, visible).forEach(item => {
        const letter = initial(item);
        if (grouped && letter !== previous) {
          const group = el('section', 'ct-browser-group');
          const heading = el('h3', '', letter);heading.id = 'ct-' + panel.dataset.kind + '-letter-' + letter.replace('#', 'number');group.setAttribute('aria-labelledby', heading.id);
          groupList = el('ul', 'ct-browser-list');group.append(heading, groupList);fragment.append(group);previous = letter;
        }
        groupList.append(renderCard(item));
      });
      if (!found.length) fragment.append(el('p', 'ct-browser-empty', strings.noResults));
      list.replaceChildren(fragment);
      more.hidden = visible >= found.length;
      status.textContent = found.length + ' ' + strings.results;
      reset.hidden = !(search.value.trim() || sport.value || activeGroup || league.value || activeLetter);
      panel.setAttribute('aria-busy', 'false');
    };
    function filter() {
      if (!pool) return;
      const words = normalize(search.value).trim().split(/\s+/).filter(Boolean);
      const matching = pool.filter(item => members(item).some(withinScope) && words.every(word => (playerView ? item.nameSearch : normalize([item.n, item.a].join(' '))).includes(word)));
      const letters = new Set(matching.map(initial));
      letterButtons.forEach((button, letter) => {button.disabled = Boolean(letter && !letters.has(letter));button.setAttribute('aria-pressed', String(letter === activeLetter));});
      chips.forEach(chip => chip.setAttribute('aria-pressed', String(chip.dataset.ctDirectoryGroup === activeGroup)));
      found = matching.filter(item => !activeLetter || initial(item) === activeLetter);
      visible = 24;paint();saveState();
    }
    async function start() {
      if (loading || pool) return;
      started = true;loading = true;panel.setAttribute('aria-busy', 'true');
      try {
        core = await coreFor(panel);
        const players = playerView ? await playersFor(sources.players, core) : null;
        pool = [...(playerView ? players.players.filter(player => !player.alias_of) : core.teams)].sort((a, b) => (initial(a) === '#') - (initial(b) === '#') || collator.compare(a.n, b.n));
        panel.querySelector('[data-ct-team-total]').textContent = String(core.teams.length);
        panel.querySelector('[data-ct-player-total]').textContent = String(core.counts?.players || players?.players.length || '');
        updateLeagues(params.get('ctleague') || '');filter();
      } catch {
        panel.setAttribute('aria-busy', 'false');status.textContent = strings.loadError + ' ';
        const retry = el('button', 'ct-text-link', strings.retry);retry.type = 'button';retry.addEventListener('click', start, {once: true});status.append(retry);
      } finally {loading = false;}
    }
    search.addEventListener('input', () => {if (!started) start();clearTimeout(pending);pending = setTimeout(() => {activeLetter = '';filter();}, 100);});
    sport.addEventListener('change', () => {activeGroup = '';activeLetter = '';if (core) {updateLeagues('');filter();}});
    league.addEventListener('change', () => {activeLetter = '';filter();});
    chips.forEach(chip => chip.addEventListener('click', () => {activeGroup = chip.dataset.ctDirectoryGroup;sport.value = '';activeLetter = '';if (core) {updateLeagues('');filter();}}));
    reset.addEventListener('click', () => {clearTimeout(pending);search.value = '';sport.value = '';activeGroup = '';activeLetter = '';updateLeagues('');filter();search.focus({preventScroll: true});});
    more.addEventListener('click', () => {
      const firstNew = visible;visible += 24;paint();list.querySelectorAll('.ct-browser-card')[firstNew]?.focus({preventScroll: true});
    });
    if (!('IntersectionObserver' in window)) start();
    else {
      const observer = new IntersectionObserver(entries => {if (entries.some(entry => entry.isIntersecting)) {observer.disconnect();start();}}, {rootMargin: '160px'});observer.observe(panel);
    }
  }
  async function initVirtual(panel) {
    const strings = JSON.parse(panel.querySelector('[data-ct-virtual-strings]').textContent);
    try {
      const core = await coreFor(panel);
      const nodes = new Map();core.groups.forEach(group => nodes.set(group.h, group));core.teams.forEach(team => nodes.set(team.h, {...team, type: 'team'}));
      let current = nodes.get(panel.dataset.handle);
      let roster;
      let players;
      let context = teamContext(core);
      if (current?.type === 'team') {
        roster = await playersFor(sources.branches[current.parent], core);players = roster.players;
      } else if (panel.dataset.handle.startsWith('ct-player-')) {
        roster = context ? await playersFor(sources.branches[context.parent], core) : null;
        players = roster?.players;
        const player = players?.find(item => item.h === panel.dataset.handle);
        if (!player || !player.teams.includes(context.id)) {context = null;roster = null;players = (await playersFor(sources.players, core)).players;}
      }
      players?.forEach(player => nodes.set(player.h, {...player, type: 'player', parent: 'ct-players'}));
      current = nodes.get(panel.dataset.handle);if (!current) throw new Error('Unknown catalog branch');
      const global = current.h === 'ct-teams' || current.h === 'ct-players';
      const playersById = new Map((players || []).map(player => [player.id, nodes.get(player.h)]));
      const children = current.type === 'team' ? (roster.rosters[current.h] || []).map(id => playersById.get(id)).filter(Boolean)
        : current.type === 'player' ? context ? roster.rosters[context.h].map(id => playersById.get(id)).filter(Boolean) : current.teams.map(id => core.byId.get(id)).filter(Boolean)
        : (current.children || []).map(handle => nodes.get(handle)).filter(Boolean);
      panel.dataset.nodeType = current.type;
      const ancestry = [];const seen = new Set([current.h]);let ancestor = context && current.type === 'player' ? nodes.get(context.h) : nodes.get(current.parent);
      while (ancestor && !seen.has(ancestor.h)) {ancestry.unshift(ancestor);seen.add(ancestor.h);ancestor = nodes.get(ancestor.parent);}
      const breadcrumb = panel.querySelector('[data-ct-virtual-breadcrumb]');const home = el('a', '', strings.home);home.href = panel.dataset.home;breadcrumb.append(home);
      ancestry.forEach(item => {const anchor = link(panel, item);anchor.textContent = item.n;breadcrumb.append(el('span', '', '/'), anchor);});
      const label = el('span', '', current.n);label.setAttribute('aria-current', 'page');breadcrumb.append(el('span', '', '/'), label);
      const title = panel.querySelector('[data-ct-virtual-title]');if (!global && current.type !== 'player') title.append(badge(panel, current));title.append(el('h1', '', global ? current.h === 'ct-players' ? strings.shopPlayer : strings.shopTeam : current.n));
      document.title = current.n + ' — ' + panel.dataset.brand;
      if (!global) {
        if (ancestry.length) {const parent = ancestry[ancestry.length - 1];const anchor = link(panel, parent, 'ct-context-parent');anchor.textContent = parent.n;panel.querySelector('[data-ct-virtual-parent]').append(anchor);}
        const heading = current.type === 'team' || context && current.type === 'player' ? strings.players : current.type === 'player' ? strings.related : current.h === 'ct-european-football' ? strings.countries : current.h === 'ct-national-teams' ? strings.confederations : children.some(item => item.id?.startsWith('TM-')) ? strings.teams : strings.collections;
        panel.querySelector('[data-ct-virtual-side-heading]').textContent = heading;panel.querySelector('[data-ct-virtual-count]').textContent = String(children.length);
        const sideList = panel.querySelector('[data-ct-context-links]');const fragment = document.createDocumentFragment();
        children.forEach(item => fragment.append(choice(panel, item, current.type === 'team' ? current : context, item.id === (current.alias_of || current.id))));sideList.replaceChildren(fragment);
      }
      panel.querySelector('[data-ct-virtual-content]').hidden = false;panel.querySelector('[data-ct-virtual-loading]').hidden = true;
      panel.dispatchEvent(new CustomEvent('ct:catalog-ready', {bubbles: true}));
    } catch {panel.querySelector('[data-ct-virtual-loading]').hidden = true;panel.querySelector('[data-ct-virtual-failure]').hidden = false;}
  }
  const init = root => root.querySelectorAll('[data-ct-directory]').forEach(initBrowser);
  init(document);
  const virtual = document.querySelector('[data-ct-virtual]');if (virtual) initVirtual(virtual);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
